/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Delivery extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Delivery;


// WEBPACK FOOTER //
// ./src/routes/searchDelivery/index.js